import { open as maskingOpen } from '../masking/methods';
export function open(Component) {
  return maskingOpen(Component, 'ARCO_ACTION_SHEET');
}